import MailchimpFormContainer from './MailchimpFormContainer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import {
  faFacebookF,
  faXTwitter,
  faYoutube,
  faLinkedinIn,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons'
import './footer.css'
import { DMCA, PRIVACY_POLICY, TERMS_CONDITIONS } from '../../constants/Routes'

export const Footer = () => {
  return (
    <footer
      id="colophon"
      className="site-footer tikbox-footer"
      role="contentinfo"
      itemScope="itemscope"
      itemType="http://schema.org/WPFooter">
      <div className="content">
        <div className="tikbox-footer__top">
          <div className="container-fluid">
            <div className="tikbox-row">
              <div className="tikbox-column">
                <h6>UK Government Consultation on Copyrights and AI</h6>
                <p>
                The consultation seeks to balance creative and AI interests - but you can act now to protect your assets
                </p> 
                <ul>
                  <li>
                    <a target="_blank" href="#" rel="noreferrer">
                      <FontAwesomeIcon icon={faChevronRight} />
                      How to Protect Your Copyrights from AI Training: Key Takeaways from the UK Government Consultation
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="#" rel="noreferrer">
                      <FontAwesomeIcon icon={faChevronRight} />
                      UK’s AI Copyright Rules Are Changing - Here’s What You Need to Do to Stay Compliant
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="#" rel="noreferrer">
                      <FontAwesomeIcon icon={faChevronRight} />
                      Opting Out of AI Text and Data Mining in the UK: What Rights Holders Must Know Now
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="#" rel="noreferrer">
                      <FontAwesomeIcon icon={faChevronRight} />
                      AI-Generated Content and Your IP: How to Label, Protect, and Comply Under UK Law
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="#" rel="noreferrer">
                      <FontAwesomeIcon icon={faChevronRight} />
                      New UK Rules on Copyright and AI: 3 Steps to Safeguard Your Creative Work Today
                    </a>
                  </li>
                </ul>
              </div>
              <div className="tikbox-column">
                <h6>EU AI ACT - COMPLIANCE DEADLINE 2 AUG 2026</h6>
                <p>
                  The Act covers documentation, transparency, and copyright
                  compliance for AI-generated content
                </p>
                <ul>
                  <li>
                    <a target="_blank" href="#" rel="noreferrer">
                      <FontAwesomeIcon icon={faChevronRight} />
                      Ensuring Copyright Compliance in AI Development with the
                      EU AI Act
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="#" rel="noreferrer">
                      <FontAwesomeIcon icon={faChevronRight} />
                      Steps to Document AI Training Data as Required by the EU
                      AI Act
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="#" rel="noreferrer">
                      <FontAwesomeIcon icon={faChevronRight} />
                      How Developers can Comply with Opt-out Reservations of
                      Creators
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="#" rel="noreferrer">
                      <FontAwesomeIcon icon={faChevronRight} />
                      Use an API to Obtain Rightsholders' Permissions for AI
                      Training
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="#" rel="noreferrer">
                      <FontAwesomeIcon icon={faChevronRight} />
                      Using Royalty Free Content for AI Training
                    </a>
                  </li>
                </ul>
              </div>
              <div className="tikbox-column">
                <h6>LICENSING TO COMMERCIALISE ON CREATIVE COPYRIGHTS</h6>
                <p>
                  TikBox guides for creators to navigate the complexities of
                  copyright and licensing for their digital content
                </p>
                <ul>
                  <li>
                    <a target="_blank" href="https://blog.tikbox.io/legal/guide-on-how-to-license-your-photos-for-commercial-use/" rel="noreferrer">
                      <FontAwesomeIcon icon={faChevronRight} />
                      Step-by-Step Guide to Licensing Your Creative Works for Commercial Use
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://blog.tikbox.io/legal/understanding-creative-commons-licences-boost-exposure-and-revenue/" rel="noreferrer">
                      <FontAwesomeIcon icon={faChevronRight} />
                      Understanding Creative Commons Licenses - Boosting Exposure and Revenue 
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://blog.tikbox.io/legal/how-to-licence-photos-for-commercial-use/" rel="noreferrer">
                      <FontAwesomeIcon icon={faChevronRight} />
                      License Photos for Commercial Use 
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://blog.tikbox.io/legal/licence-photos-and-your-creative-assets-for-ai-training/" rel="noreferrer">
                      <FontAwesomeIcon icon={faChevronRight} />
                      License Photos and Your Creative Assets for AI Training 
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://blog.tikbox.io/legal/using-creative-commons-content-for-ai-training-legal-and-ethical-guide/" rel="noreferrer">
                      <FontAwesomeIcon icon={faChevronRight} />
                      Content for AI Training : Legal and Ethical Guide for Developers
                    </a>
                  </li>
                </ul>
              </div>
              <div className="tikbox-column">
                <h6>NEWSLETTER SIGN UP</h6>
                <div
                  id="footer-sidebar-first"
                  className="footer-sidebar-first widget-area"
                  role="complementary">
                  <MailchimpFormContainer />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="tikbox-footer__middle"></div>

        <div className="tikbox-footer__bottom">
          <div className="container-fluid">
            <div className="tikbox-row">
              <div className="tikbox-column">
                <ul className="tikbox_social_links">
                  <li>
                    <a href="#" target="_blank" rel="noreferrer">
                      <FontAwesomeIcon icon={faXTwitter} />
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank" rel="noreferrer">
                      <FontAwesomeIcon icon={faFacebookF} />
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank" rel="noreferrer">
                      <FontAwesomeIcon icon={faInstagram} />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/tikbox-io/"
                      target="_blank"
                      rel="noreferrer">
                      <FontAwesomeIcon icon={faLinkedinIn} />
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank" rel="noreferrer">
                      <FontAwesomeIcon icon={faYoutube} />
                    </a>
                  </li>
                </ul>
              </div>
              <div className="tikbox-column">
                <ul>
                  <li>
                    <Link to={TERMS_CONDITIONS}>Ts & Cs</Link>
                  </li>
                  <li>
                    <Link to={PRIVACY_POLICY}>Privacy</Link>
                  </li>
                </ul>
              </div>
              <div className="tikbox-column">
                <ul>
                  <li>
                    <Link to={DMCA}>DMCA</Link>
                  </li>
                </ul>
              </div>
              <div className="tikbox-column">
                <div className="tikbox-copyright">© Copyright Tikbox 2024</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
